import React, {Component} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {CmsLinksFooter} from '../../components/cms/'

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Container className="py-5 border-top-2">
          <Row>
            <Col xs="6" sm="4" md="2"lg="2">
              <img alt="logo-footer"className="images" src="/images/logo/logo-footer.png"/>
            </Col>
            <Col xs="12" sm="12" md="10"lg="10">
              <CmsLinksFooter category={3}/>
            </Col>
          </Row>
        </Container>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Footer/index.js